import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tz/go/egaz/osci/ptl/comn";

export const BASE = {
    path: `${ptlEnvs.base}/intf/hist`,
    api: `${process.env.REACT_APP_API_PTL_COMN}/api/v1/osci/ptl/intf/hist`,
};

export const URLS = {
    osci0113001q: `${BASE.path}/osci0113001q`,
    osci0113002s: `${BASE.path}/osci0113002s`,
};

export const APIS = {
    // Get a list of Send/Receive iinterface documents. !== 인터페이스 송/수신 목록을 조회한다. ==!
    getIntfDocHistList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Select Receive electronic documents details !== 전자문서 수신 상세 정보 조회 ==!
    getIntfDocHist: (trscLogId: any) => {
        return api.get(`${BASE.api}/${trscLogId}`);
    },
    // Update sending electronic documents !== 전자문서 수신 수정 ==!
    insertIntfDocResd: (data: any) => {
        return api.put(`${BASE.api}`, {
            ...data,
        });
    },
};

export const SF_INTF_DOC_HIST_SRCH: TFormSchema = {
    id: "form_intfDocHistSrch",
    schema: {
        intfId: {
            type: "text",
            label: "L_INTF_ID",
        },
        /* Transaction Log ID !== 거래 로그 ID ==! */
        trscLogId: {
            type: "text",
            label: "L_TRSC_LOG_ID",
        },
        startTimeRnge: {
            type: "daterange",
            label: "L_RGSR_DT",
            start: { name: "startFrstRgsrDtm" },
            end: { name: "endFrstRgsrDtm" },
            rangeButton: 5,
        },
        sendOrgCd: {
            type: "select",
            label: "L_SEND_CD",
            area: "orgAbrt",
        },
        rcveOrgCd: {
            type: "select",
            label: "L_RCVE_CD",
            area: "orgAbrt",
        },
        trscStatCd: {
            type: "select",
            label: "L_PRCSS_STAT",
            all: true,
            area: "comnCd",
            comnCd: "OSC0102",
        },
        sndrcvDvnCd: {
            type: "select",
            label: "L_SNDRCV_DVN_NM",
            all: true,
            area: "comnCd",
            comnCd: "OSC0109",
            excludes: ["C"],
        },
        kwdSel: {
            type: "select",
            label: "L_KWD",
            options: [
                { label: "L_APP_NO", value: "A" },
                { label: "L_TANSAD_NO", value: "B" },
                { label: "L_MRN", value: "C" },
                { label: "L_BL_NO_1", value: "D" },
                { label: "L_BLL_NO", value: "E" },
                { label: "L_REFF_NO", value: "F" },
            ],
        },
        /* Search keyword Select Option Name !== 검색어 ==!*/
        kwdTxt: {
            type: "text",
            readOnly: true,
        },
    },
};

export const SG_INTF_DOC_HIST_LIST: TGridSchema = {
    id: "grid_intfDocHistList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_TRSC_LOG_ID", binding: "trscLogId", width: 280, rowspan: 2 }] },
        {
            cells: [
                { header: "L_INTF_ID", binding: "intfId", width: 160 },
                { header: "L_SNDRCV_DVN_NM", binding: "sndrcvDvnCd", width: 160 },
            ],
        },
        {
            cells: [
                { header: "L_SEND_ID", binding: "sendOrgId", width: "*" },
                { header: "L_SEND_CD", binding: "sendOrgCd", width: "*" },
            ],
        },
        {
            cells: [
                { header: "L_RCVE_ID", binding: "rcveOrgId", width: "*" },
                { header: "L_RCVE_CD", binding: "rcveOrgCd", width: "*" },
            ],
        },
        {
            cells: [
                { header: "L_APP_NO", binding: "appNo", width: 160 },
                { header: "L_TANSAD_NO", binding: "tansadNo", width: 160 },
            ],
        },
        {
            cells: [
                { header: "L_MRN", binding: "mrn", width: 160 },
                { header: "L_BL_NO_1", binding: "blNo", width: 160 },
            ],
        },
        {
            cells: [
                { header: "L_BLL_NO", binding: "bllNo", width: 160 },
                { header: "L_REFF_NO", binding: "reffNo", width: 160 },
            ],
        },
        {
            cells: [
                { header: "L_FRST_RGSR_DTM", binding: "frstRgsrDtm", width: 160 },
                { header: "L_PRCSS_STAT", binding: "trscStatCd", width: 160 },
            ],
        },
    ],
    body: [
        { cells: [{ binding: "trscLogId", rowspan: 2 }] },
        { cells: [{ binding: "intfId" }, { binding: "sndrcvDvnCd", type: "code", area: "comnCd", comnCd: "OSC0109" }] },
        {
            cells: [
                { binding: "sendOrgId" },
                { binding: "sendOrgCd", type: "select", area: "orgAbrt", viewType: "label" },
            ],
        },
        {
            cells: [
                { binding: "rcveOrgId" },
                { binding: "rcveOrgCd", type: "select", area: "orgAbrt", viewType: "label" },
            ],
        },
        {
            cells: [
                { binding: "appNo", align: "left" },
                { binding: "tansadNo", align: "left" },
            ],
        },
        { cells: [{ binding: "mrn", align: "left" }, { binding: "blNo" }] },
        { cells: [{ binding: "bllNo", align: "left" }, { binding: "reffNo" }] },
        {
            cells: [
                { binding: "frstRgsrDtm", type: "datetime" },
                { binding: "trscStatCd", type: "code", area: "comnCd", comnCd: "OSC0102", viewType: "label" },
            ],
        },
    ],
};

export const SF_INTF_DOC_HIST_INFO: TFormSchema = {
    id: "form_docRcpnMgmtInfo",
    schema: {
        trscLogId: { type: "text", label: "L_TRSC_LOG_ID", edit: false },
        intfId: { type: "text", label: "L_INTF_ID", edit: false },
        intfNm: { type: "text", label: "L_INTF_NM", edit: false },
        sndrcvDvnCd: { type: "select", label: "L_SNDRCV_DVN_NM", area: "comnCd", comnCd: "OSC0109", edit: false },
        orgEnpoId: { type: "text", label: "L_ORG_ENPO_ID", edit: false },
        trscRqstId: { type: "text", label: "L_ORG_ENPO_ID", edit: false },

        sendOrgId: { type: "text", label: "L_SEND_ID", edit: false },
        sendOrgCd: { type: "select", label: "L_SEND_CD", area: "orgCd", edit: false },
        rcveOrgId: { type: "text", label: "L_RCVE_ID", edit: false },
        rcveOrgCd: { type: "select", label: "L_RCVE_CD", area: "orgCd", edit: false },
        frstRgsrDtm: { type: "datetime", label: "L_FRST_RGSR_DTM", edit: false },
        trscStatCd: { type: "code", label: "L_PRCSS_STAT", area: "comnCd", comnCd: "OSC0102", edit: false },

        trmssnFailCn: { type: "textarea", label: "L_ERR_MSG_CN", edit: false },
        trmssnMsgCn: { type: "textarea", label: "L_MSG_ORGN_CN", edit: false },
        rspnMsgCn: { type: "textarea", label: "L_MSG_ACK_CN", edit: false },

        appNo: { type: "text", label: "L_APP_NO", edit: false },
        tansadNo: { type: "text", label: "L_TANSAD_NO", edit: false },
        mrn: { type: "text", label: "L_MRN", edit: false },
        blNo: { type: "text", label: "L_BL_NO_1", edit: false },
        bllNo: { type: "text", label: "L_BLL_NO", edit: false },
        reffNo: { type: "text", label: "L_REFF_NO", edit: false },
    },
};

export const SG_INTF_DOC_HIST_LIST2: TGridSchema = {
    id: "grid_intfDocHistList2",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_TRSC_LOG_ID", binding: "trscLogId", width: "*" }] },
        { cells: [{ header: "L_FRST_RGSR_DTM", binding: "frstRgsrDtm", width: "*" }] },
        { cells: [{ header: "L_PRCSS_STAT", binding: "trscStatCd", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "trscLogId" }] },
        { cells: [{ binding: "frstRgsrDtm", type: "datetime" }] },
        { cells: [{ binding: "trscStatCd", type: "code", area: "comnCd", comnCd: "OSC0102" }] },
    ],
};

export const SF_MSG_INFO: TFormSchema = {
    id: "form_msgInfo",
    schema: {
        msg: { type: "textarea", label: "L_MSG_CN", edit: false },
    },
};
